module.exports = "data:text/markdown;base64,IyMjIFByb3NwZWN0cwoKVGhlIHRvdGFsIG51bWJlciBvZiBwcm9zcGVjdHMgb24gYSBsaXN0Lgo="